module.exports = __webpack_public_path__ + "static/fipcbiglove1-6726eb1f1379d77c061b68b381cfbade.jpeg";